export const  setupRequestResourceName = 'Setup Requests';

export const EPAYMENT_SERVICE_NA	= 0;
export const EPAYMENT_SERVICE_AIRPAY = 1;
export const EPAYMENT_SERVICE_ALIPAY = 2;
export const EPAYMENT_SERVICE_WECHAT_PAY = 3;

export const EPAYMENT_SERVICE_CODE_NAME_MAP = {
  [EPAYMENT_SERVICE_AIRPAY]: "AirPay",
  [EPAYMENT_SERVICE_ALIPAY]: "Alipay",
  [EPAYMENT_SERVICE_WECHAT_PAY]: "WeChat Pay",
}

export const EPAYMENT_PROVIDER_NA	= 0;
export const EPAYMENT_PROVIDER_AIRPAY = 1;
export const EPAYMENT_PROVIDER_GHL = 2;

export const SERVICE_PROVIDER_CHOICE = {
  [EPAYMENT_SERVICE_AIRPAY]: [],
  [EPAYMENT_SERVICE_ALIPAY]: [
    { id: EPAYMENT_PROVIDER_AIRPAY, name: 'AIRPAY' },
    { id: EPAYMENT_PROVIDER_GHL, name: 'GHL' },
  ],
  [EPAYMENT_SERVICE_WECHAT_PAY]: [
    { id: EPAYMENT_PROVIDER_AIRPAY, name: 'AIRPAY' },
    { id: EPAYMENT_PROVIDER_GHL, name: 'GHL' },
  ],
};

export const AIRPAY_MERCHANT_LINKING_NA = 0;
export const AIRPAY_MERCHANT_LINKING_NOT_LINKED = 1;
export const AIRPAY_MERCHANT_LINKING_LINKED = 2;



// WEBPACK FOOTER //
// ./src/routes/e_payment/utils.js